import React from 'react';
import clsx from 'clsx';

/**
 * A component that renders a list of radio buttons from a list of options.
 *
 * @param {object} props - The component props.
 * @param {string} [props.inputClasses] - Additional CSS classes for the radio inputs.
 * @param {string} [props.wrapperClasses] - Additional CSS classes for the component wrapper fieldset.
 * @param {string} [props.labelClasses] - Additional CSS classes for the legend.
 * @param {string} props.label - The text to display for the legend.
 * @param {Array<object>} props.options - An array of option objects.
 * @param {number} props.options[].id - The unique ID of the option.
 * @param {string} props.options[].optionLabel - The label for the option.
 * @param {boolean} props.options[].selected - Whether the option is selected.
 * @param {function(value: number): void} props.handleRadioChange - The function to call when a radio button is changed.
 */
export const ChooseOne = ({
  inputClasses,
  wrapperClasses,
  labelClasses,
  label,
  options,
  handleRadioChange,
}) => {

  return (
    <fieldset
      className={clsx(wrapperClasses, 'custom-form-field--choose-one')}
    >
      <legend
        className={labelClasses}
      >
        {label}
      </legend>
      <div className="custom-form-field__options-list">
        {options.map(({ id, optionLabel, selected }, index) => (
          <div className="custom-form-field__option">
            <input
              key={`choose-one-${id}--${index}`}
              id={`choose-one-${id}--${index}`}
              type="radio"
              name={id}
              value={selected}
              checked={selected}
              onChange={(e) => handleRadioChange(id, e.target.value)}
              className={clsx(inputClasses)}
            />
            <label
              htmlFor={`choose-one-${id}--${index}`}
            >
              {optionLabel}
            </label>
          </div>
        ))}
      </div>
    </fieldset>
  );
};
